module.exports = __webpack_public_path__ + "img/logo-hub-light-bg.svg";